import Swipe from './Swipe.vue';
import SwipeList from './SwipeList.vue';
export default {
  Swipe,
  SwipeList,
};
